import {
  ONTOLOGIES_SET,
  ONTOLOGY_ADDED,
  ONTOLOGY_DELETED,
  ONTOLOGIES_DELETED,
  ONTOLOGY_EDITED,
} from 'src/app/redux/redux-types';
import { reduxOntologyTypes } from 'src/types';

export const ontologyDefaultState: reduxOntologyTypes.StateType = {
  ontologies: [],
};

export const ontologyReducer = (
  state = ontologyDefaultState,
  action: reduxOntologyTypes.ActionType,
): reduxOntologyTypes.StateType => {
  switch (action.type) {
    case ONTOLOGIES_SET:
      return {
        ...state,
        ontologies: action.payload,
      };
    case ONTOLOGY_ADDED:
      // state.ontologies.push(action.payload);
      const exists = state.ontologies.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        ontologies: [action.payload, ...state.ontologies],
      };
    case ONTOLOGY_EDITED:
      const updateIndex = state.ontologies.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        ontologies: [
          ...state.ontologies.slice(0, updateIndex),
          action.payload,
          ...state.ontologies.slice(updateIndex + 1),
        ],
      };
    case ONTOLOGY_DELETED:
      return {
        ...state,
        ontologies: state.ontologies.filter((o) => o.id !== action.payload),
      };
    case ONTOLOGIES_DELETED:
      return {
        ...state,
        ontologies: state.ontologies.filter((o) => !action.payload.includes(o.id)),
      };
    default:
      return state;
  }
};
